import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@mui/material';
import { standardIcons } from './NIconsSVG';
import { nIcon } from './NIcon.styles';
export const NIcon = ({ name, size = 'md', color }) => {
    const iconKey = `${name}-${size}`;
    const iconSvg = standardIcons[iconKey];
    return (_jsx(Box, { sx: { ...nIcon(size), ...(color ? { color } : {}) }, children: iconSvg && iconSvg.length > 0 && (_jsx("svg", { width: size === 'sm' ? '16' : '24', height: size === 'sm' ? '16' : '24', viewBox: size === 'sm' ? '0 0 16 16' : '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', children: _jsx("g", { id: iconKey, children: iconSvg.map((pathD) => (_jsx("path", { id: 'Vector', d: pathD, fill: 'currentColor' }, pathD))) }) })) }));
};
//# sourceMappingURL=NIcon.js.map